module.exports = __webpack_public_path__ + "img/logo-full-blue.c924c6e4.svg";